import { createAccessTokenLoader } from '@steelbuy/api-integration';

export const createDataProviderAccessTokenLoader = createAccessTokenLoader;
